module.exports = __webpack_public_path__ + "img/vessel.83f13735.jpg";